import React, { Component } from "react";
import { Button ,Input,FormFeedback} from "reactstrap";
import Joi from "joi-browser";
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
let logo = require("../resources/images/logo.png");


class ForgetPassword extends Component {
  state = {
    mobileNumber: "",

    errors: {}
  };

  schema = Joi.object().keys({
    mobileNumber: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "موبائل نمبر ضروری ہے"
        };
      })
  });

  reset = () => {
    let errors = {};
    this.setState({ mobileNumber: "", errors });
  };

  // sign up validation
  validation() {
    let { error } = Joi.validate({ mobileNumber: this.state.mobileNumber}, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  // Submit handler
  handleSubmit = async event => {
    event.preventDefault();

    // validation
    let errors = this.validation();
    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }



    try {
      var { status } = await httpClient.post("/user/forget",{mobileNumber:this.state.mobileNumber});

     
      if (status === 200) {
        // show verification modal
        toast.success("-آپ کا پاس ورڈ آپ کے موبائل نمبر پہ بھیج دیا گیا ہے",{
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });

      }
    } catch (error) {
      // error occur

      let { status } = error.response;
      if (status === 400) {
        toast.info("یہ موبائل نمبر رجسٹر نہیں ہے", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      } else {
        toast.error("کچھ دیر بعد کوشش کریں _ ہم معزرت خواہ ہیں", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      }
    }
  };

  render() {

    let { mobileNumber,errors} = this.state;

  

    return (
      <div
        
        className="text-center bg-forget-password"
        style={{ backgroundColor: "#f8f9fa", height: "100%" }}
      >
        {/* toast notifiction */}
        <form className="form-signin">
          <img
            src={logo}
            className="img-fluid  mb-4"
            alt=""
            style={{ width: "220px", height: "72" }}
          />
          {/* <img className="mb-4" src="/docs/4.2/assets/brand/bootstrap-solid.svg" alt="" width="72" height="72" /> */}
          <h1 className="h3 mb-3 font-weight-normal">پاسورڈ بھول گے</h1>
          <label htmlFor="mobileNumber" className="sr-only">
            Mobile Number
          </label>
          <Input
            type="text"
            name="mobileNumber"
            value={mobileNumber}
            id="mobileNumber"
            
            placeholder="موبائل نمبر"
             invalid={Boolean(errors["mobileNumber"])}
            onChange={(e)=>{ this.setState({mobileNumber:e.target.value})}}
            
          />
          {errors["mobileNumber"] && (
                    <FormFeedback>{errors["mobileNumber"]}</FormFeedback>
                  )}

          <div className="float-left ml-2 mt-2" >
          <Button
            className="small"
            color="secondary"
            onClick={()=>{ this.props.history.push("/")}}
          >
           سائن ان صفحے پر واپس جائیں
          </Button>

          <Button
            className="small ml-1"
            color="primary"
            onClick={this.handleSubmit}
          >
           جمع کرائیں
          </Button>
          </div>
       

          {/* <button className="btn btn-primary  mt-2" type="submit">
            Submit
          </button> */}
          <p  style={{ paddingBottom:"40%", marginTop:"5rem" }} className="text-muted">
            &copy; Gamdi {new Date().getFullYear()}
          </p>
        </form>

        <ToastContainer  pauseOnVisibilityChange={false} />
        {/* end footer */}
      </div>
    );
  }
}

export default ForgetPassword;
